import React, { useContext } from 'react';
import { ConfigProvider, theme } from 'antd';
import { DarkModeProvider, DarkModeContext } from '../context/DarkModeContext';
import { T } from './useTheme';

const { defaultAlgorithm, darkAlgorithm } = theme;

const AntThemeWrapper = ({ children }) => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <ConfigProvider
      theme={{
        algorithm: darkMode ? darkAlgorithm : defaultAlgorithm,
        token: {
          colorPrimary: darkMode ? T.brandDark : T.brand,
          colorPrimaryHover: darkMode ? T.brandDarkHover : T.brandHover,
          colorPrimaryBg: darkMode ? T.brandDarkSoft : T.brandSoft,
          borderRadius: 10,
          colorBgContainer: darkMode ? T.dSurface : T.lSurface,
          colorBgElevated: darkMode ? T.dElevated : T.lSurface,
          colorText: darkMode ? T.dText : T.lText,
          colorTextSecondary: darkMode ? T.dTextSec : T.lTextSec,
          colorTextTertiary: darkMode ? T.dTextMuted : T.lTextMuted,
          colorBorder: darkMode ? T.dBorder : T.lBorder,
          colorBorderSecondary: darkMode ? T.dBorderMd : T.lBorderMd,
          colorIcon: darkMode ? T.dIcon : T.lIcon,
          colorIconHover: darkMode ? T.dText : T.lText,
        },
        components: {
          Button: {
            colorPrimary: darkMode ? T.brandDark : T.brand,
            colorPrimaryHover: darkMode ? T.brandDarkHover : T.brandHover,
            colorPrimaryActive: darkMode ? T.brandDarkHover : T.brandHover,
            colorBgContainerDisabled: darkMode ? T.dMuted : T.lMuted,
            colorBorderDisabled: darkMode ? T.dBorder : T.lBorder,
            colorTextDisabled: darkMode ? T.dTextMuted : T.lTextMuted,
            primaryShadow: `0 6px 16px ${darkMode ? T.brandDarkSoft : T.brandSoft}`,
            controlHeight: 40,
            borderRadius: 10,
          },
          Input: {
            activeBorderColor: darkMode ? T.brandDark : T.brand,
            hoverBorderColor: darkMode ? T.brandDark : T.brand,
            activeShadow: `0 0 0 3px ${darkMode ? T.brandDarkSoft : T.brandSoft}`,
            colorTextPlaceholder: darkMode ? T.dTextMuted : T.lTextMuted,
            controlHeight: 40,
          },
          Select: {
            activeBorderColor: darkMode ? T.brandDark : T.brand,
            hoverBorderColor: darkMode ? T.brandDark : T.brand,
            optionSelectedBg: darkMode ? T.brandDarkSoft : T.brandSoft,
            optionSelectedColor: darkMode ? T.dText : T.lText,
            controlHeight: 40,
          },
          Card: {
            colorBgContainer: darkMode ? T.dSurface : T.lSurface,
            colorBorderSecondary: darkMode ? T.dBorder : T.lBorder,
            boxShadowTertiary: darkMode ? "0 4px 12px rgba(0,0,0,0.40)" : "0 4px 12px rgba(0,0,0,0.08)",
          },
          Table: {
            headerBg: darkMode ? T.dElevated : T.lMuted,
            headerColor: darkMode ? T.dText : T.lText,
            rowHoverBg: darkMode ? T.dMuted : T.lMuted,
            borderColor: darkMode ? T.dBorder : T.lBorder,
          },
          Modal: {
            headerBg: darkMode ? T.dElevated : T.lSurface,
            contentBg: darkMode ? T.dSurface : T.lSurface,
            footerBg: darkMode ? T.dSurface : T.lSurface,
          },
          Popover: {
            colorBgElevated: darkMode ? T.dMuted : T.lSurface,
          },
          Tag: {
            borderRadiusSM: 999,
            fontSizeSM: 12,
          },
          Switch: {
            colorPrimary: darkMode ? T.brandDark : T.brand,
            colorPrimaryHover: darkMode ? T.brandDarkHover : T.brandHover,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export const ThemeProvider = ({ children }) => (
  <DarkModeProvider>
    <AntThemeWrapper>
      {children}
    </AntThemeWrapper>
  </DarkModeProvider>
);
